import { PostJourneysGetJourneyResponse } from 'src/sdk_checkin';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib';
import { CprResultModel } from './cpr-result.state';

/** StateDetailsActions */
const ACTION_SET = '[CprResult] set';
const ACTION_UPDATE = '[CprResult] update';
const ACTION_RESET = '[CprResult] reset';
const ACTION_FAIL = '[CprResult] fail';
const ACTION_CANCEL_REQUEST = '[CprResult] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[CprResult] set from api';
const ACTION_UPDATE_FROM_API = '[CprResult] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setCprResult = createAction(ACTION_SET, props<WithRequestId<CprResultModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateCprResult = createAction(ACTION_UPDATE, props<WithRequestId<Partial<CprResultModel>>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetCprResult = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelCprResultRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failCprResult = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setCprResultFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<PostJourneysGetJourneyResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateCprResultFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<PostJourneysGetJourneyResponse>>()
);
